import { useEffect, useState } from 'react';
import { recordPageView } from '@/api/interaction';

type ViewType = 'solution' | 'tool';

export function usePageView(type: ViewType, id: string) {
  const [viewCount, setViewCount] = useState<number | null>(null);

  useEffect(() => {
    const targetId = Number(id);
    if (!Number.isInteger(targetId) || targetId <= 0) {
      setViewCount(null);
      return;
    }

    let active = true;
    const syncView = async () => {
      try {
        const res = await recordPageView({ targetType: type, targetId });
        if (!active) return;
        setViewCount(typeof res.viewCount === 'number' && Number.isFinite(res.viewCount) ? res.viewCount : null);
      } catch (err) {
        console.error('Failed to record page view:', err);
        if (active) setViewCount(null);
      }
    };

    void syncView();
    return () => {
      active = false;
    };
  }, [type, id]);

  return viewCount;
}
